module.exports = __webpack_public_path__ + "img/login-bg.23e8758b.svg";